/**
 * Props pro tlačítko akce, která je zakázaná, ale musí uživateli umět říct proč.
 *
 * `isDisabled` u UUI `Button` (react-aria) vyrenderuje **nativní `disabled`**
 * (ověřeno v DOM: `disabled=true`, `aria-disabled=null`). Prohlížeč nad takovým
 * prvkem nepouští pointer ani focus eventy, takže `Tooltip` kolem něj nikdy
 * nevystřelí a vysvětlení by nebylo vidět.
 *
 * Proto se blokovaná akce značí `aria-disabled` a ztlumí se stylem: prvek
 * zůstane najetelný i zaostřitelný (tooltip funguje myší i z klávesnice),
 * odečítač obrazovky ho dál hlásí jako zakázaný. Vlastní stisk musí volající
 * potlačit sám — `onPress={reason ? undefined : handler}`.
 */
export function blockedActionProps(reason?: string) {
  if (!reason) return {};
  return {
    "aria-disabled": true,
    // `pointer-events-none` tu být nesmí — zabilo by hover, a tím i tooltip.
    className: "cursor-not-allowed opacity-50",
  } as const;
}
